var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "700.000000pt",
    height: "450.000000pt",
    viewBox: "0 0 611.000000 480.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,480.000000) scale(0.100000,-0.100000)",
    fill: "#ffffff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2400 l0 -2400 3055 0 3055 0 0 2400 0 2400 -3055 0 -3055 0 0 -2400z m4530 1465 l0 -295 -100 0 -100 0 0 190 0 190 -1340 0 -1340 0 0 -190 0 -190 -100 0 -100 0 0 295 0 295 1540 0 1540 0 0 -295z m-2668 -1088 l3 -704 300 381 301 381 237 3 237 2 -256 -322 c-141 -178 -261 -328 -266 -335 -6 -8 69 -150 237 -445 136 -238 256 -448 267 -466 l20 -32 -238 2 -237 3 -151 270 c-83 149 -156 278 -162 288 -9 16 -30 -7 -152 -171 l-142 -189 0 -101 0 -102 -205 0 -205 0 0 1120 0 1120 205 0 205 0 2 -703z m1648 353 c0 -192 3 -350 6 -350 3 0 19 9 35 21 88 62 278 87 424 54 238 -53 436 -234 522 -480 l28 -80 3 -527 3 -528 -205 0 -205 0 -3 503 -3 502 -29 53 c-33 60 -76 101 -139 134 -35 19 -58 23 -132 23 -81 0 -95 -3 -143 -29 -60 -33 -101 -76 -134 -139 -23 -42 -23 -45 -26 -544 l-3 -503 -204 0 -205 0 0 1120 0 1120 205 0 205 0 0 -350z m-1860 -2170 l0 -190 1340 0 1340 0 0 190 0 190 100 0 100 0 0 -295 0 -295 -1540 0 -1540 0 0 295 0 295 100 0 100 0 0 -190z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.25a5a1fd697ab0cc5e5f91228fed698d.svg";
export { ForwardRef as ReactComponent };